import { render } from "./UaQcBarcodes.vue?vue&type=template&id=3a1a3057"
import script from "./UaQcBarcodes.vue?vue&type=script&lang=js"
export * from "./UaQcBarcodes.vue?vue&type=script&lang=js"

import "./UaQcBarcodes.vue?vue&type=style&index=0&id=3a1a3057&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/UaQcBarcodes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3a1a3057"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a1a3057', __exports__)) {
    console.log('reload')
    api.reload('3a1a3057', __exports__)
  }
  
  module.hot.accept("./UaQcBarcodes.vue?vue&type=template&id=3a1a3057", () => {
    console.log('re-render')
    api.rerender('3a1a3057', render)
  })

}


export default __exports__